import React, { Component } from 'react'
import './styles.css'
import { apiEmployee } from '../../services/apiamrg'
import Header from '../../components/header'
import { Link, Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes, faFilter } from '@fortawesome/free-solid-svg-icons'
import { NOME_EMPRESA } from '../../config'
import { confirmAlert } from 'react-confirm-alert'
import 'react-confirm-alert/src/react-confirm-alert.css'

const estadoInicial = {
    name: '',
    situacoes: [],
    loading: false,
    loadingPesquisa: false,
    redirect: false,
    pesquisa: '',
}

class OrdensSituacoes extends Component {

    constructor(props) {
        super(props);
        this.pdfExportComponent = React.createRef(null);
    }
    state = {
        ...estadoInicial
    }

    componentDidMount = () => {
        this.getSituacoes();
    }

    getSituacoes = async () => {
        apiEmployee.get(`pegarsituacoes`)
            .then(res => this.setState({
                situacoes: res.data
            }))
    }

    deleteSituacao = (id, nome) => {
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <div className='custom-ui text-center'>
                        <h1>{NOME_EMPRESA}</h1>
                        <div>
                            <span>Deseja apagar esta situação? ({nome})</span>
                        </div>
                        <button
                            style={{ marginRight: 5 }}
                            className="btn btn-danger w-25"
                            onClick={
                                async () => {
                                    onClose()
                                }
                            }
                        >
                            Não
                        </button>
                        <button
                            style={{ marginRight: 5 }}
                            className="btn btn-success w-25"
                            onClick={
                                async () => {
                                    await apiEmployee.delete(`apagarsituacao/${id}`).then(
                                        async response => {
                                            if (response.data == true) {
                                                document.location.reload()
                                            }
                                        },
                                        async response => {
                                            this.erroApi(response)
                                        }
                                    )
                                    onClose()
                                }
                            }

                        >
                            Sim
                        </button>
                    </div>
                )
            }
        })
    }

    filterItems = (item) => {
        return true;
    }

    render() {

        return (
            <div>
                <div
                    style={{
                        position: "absolute",
                        left: "-900000px",
                        top: 0,
                    }}
                >
                </div>
                {this.state.redirect &&
                    <Redirect to={'/admin'} />
                }
                {!this.state.loading &&
                    <div>
                        <section>
                            <Header voltar />

                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="page-breadcrumb">
                                        <h2 id='titulo'>Situações de Ordens</h2>
                                    </div>
                                </div>
                            </div>

                        </section>

                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}>

                            <Link to={{
                                pathname: `/admin/addordemsituacao/0`,
                                state: { bem: undefined }
                            }} className='butaoadicionarcardapio'> Adicionar Situação </Link>
                            <div hidden className='butaofiltros' onClick={(a) => this.setState({ expandido: !this.state.expandido })}> Filtrar  <FontAwesomeIcon icon={faFilter} size="12" color='black' /> </div>




                        </div>
                        <div style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <div className='col-11 row'>
                                <div className='col-12 row arrumaraqui25'>
                                    <div className='col-2'>
                                        Codigo

                                    </div>
                                    <div className='col-9'>
                                        Descrição
                                    </div>

                                    <div className='col-1'>


                                    </div>


                                </div>

                                {this.state.situacoes.filter(this.filterItems).map((situacao, index) => {

                                    return (
                                        <div className={`col-12 row ${index % 2 == 0 ? 'arrumaraqui26' : 'arrumaraqui27'}`} key={situacao.Chave}>
                                            <Link className='col-2' to={{
                                                pathname: `/admin/addordemsituacao/${situacao.Chave}`,
                                                state: { situacao: { ...situacao } }
                                            }}>
                                                {situacao.Codigo}

                                            </Link>

                                            <Link className='col-9' to={{
                                                pathname: `/admin/addordemsituacao/${situacao.Chave}`,
                                                state: { situacao: { ...situacao } }
                                            }}>
                                                {situacao.Descricao}

                                            </Link>

                                            <div className='col-1 lixeira'>


                                                <FontAwesomeIcon title={"apagar"} icon={faTimes} size="12" color={index % 2 == 0 ? "black" : "white"} onClick={() => this.deleteSituacao(situacao.Chave, situacao.Descricao)} />

                                            </div>


                                        </div>
                                    )
                                })}









                            </div>
                        </div>

                    </div>
                }
            </div>
        )

    }
}

const mapStateToProps = ({ user, servidor }) => {
    return {
        token: user.token,
        online: servidor.online
    }
}

export default connect(mapStateToProps, null)(OrdensSituacoes)
